<div class="validation-errors-dialog p-4 flex flex-column gap-3">
    <!-- QUOTE-LEVEL ERRORS -->

    <!-- Customer Errors -->
    @if (validation()?.quoteValidation?.customerErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-user text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.CUSTOMER' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.quoteValidation?.customerErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.quoteValidation?.customerErrors; track error.key) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('billing')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Quote Errors -->
    @if (validation()?.quoteValidation?.quoteErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-info-circle text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.QUOTE' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.quoteValidation?.quoteErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.quoteValidation?.quoteErrors; track error.key) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('quote-info')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Sales Credit Errors -->
    @if (validation()?.quoteValidation?.salesCreditErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-users text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.SALES_CREDIT' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.quoteValidation?.salesCreditErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.quoteValidation?.salesCreditErrors; track $index) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('quote-info')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Delivery Errors (quote-level) -->
    @if (validation()?.quoteValidation?.deliveryErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-warehouse text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.DELIVERY' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.quoteValidation?.deliveryErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.quoteValidation?.deliveryErrors; track error.key) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('delivery')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- VERSION-LEVEL ERRORS -->

    <!-- Shipping Errors (version-level) -->
    @if (validation()?.versionValidation?.shippingErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-truck text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.SHIPPING_COSTS' |
                translate }}</span>
            <span class="text-secondary text-sm">({{ validation()?.versionValidation?.shippingErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.versionValidation?.shippingErrors; track error.key) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('freight')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Project Errors (version-level) -->
    @if (validation()?.versionValidation?.projectErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-users text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.PROJECT' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.versionValidation?.projectErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.versionValidation?.projectErrors; track error.key) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('services')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Item Group Errors -->
    @if (validation()?.versionValidation?.itemGroupErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-folder text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.GROUPS' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.versionValidation?.itemGroupErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.versionValidation?.itemGroupErrors; track error.key) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('articles')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Item Errors -->
    @if (validation()?.versionValidation?.itemErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-box text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.ITEMS' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.versionValidation?.itemErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.versionValidation?.itemErrors; track error.key) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('articles')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Item Warnings (do not block order creation) -->
    @if (validation()?.versionValidation?.itemWarnings?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-box text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.ITEMS' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.versionValidation?.itemWarnings?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (warning of validation()?.versionValidation?.itemWarnings; track $index) {
                <li class="text-orange-500 mb-1 text-sm">{{ translateError(warning.key, warning.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToTab('articles')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Subscription Errors -->
    @if (validation()?.versionValidation?.subscriptionErrors?.length > 0) {
    <div class="surface-card border-1 surface-border border-round overflow-hidden">
        <div class="flex align-items-center gap-2 py-2 px-3 surface-100 border-bottom-1 surface-border">
            <i class="pi pi-percentage text-primary"></i>
            <span class="font-semibold text-base uppercase">{{ 'QUOTE.TOOLBAR.VALIDATION_CATEGORY.SUBSCRIPTION' | translate
                }}</span>
            <span class="text-secondary text-sm">({{ validation()?.versionValidation?.subscriptionErrors?.length }})</span>
        </div>
        <div class="p-3">
            <ul class="m-0 pl-4">
                @for (error of validation()?.versionValidation?.subscriptionErrors; track error.key) {
                <li class="text-red-600 mb-1 text-sm">{{ translateError(error.key, error.params) }}</li>
                }
            </ul>
        </div>
        <div class="flex justify-content-end align-items-center py-2 px-3 surface-50 border-top-1 surface-border cursor-pointer hover:surface-100"
            (click)="navigateToSubscriptionTab('startup-info')">
            <span class="text-sm text-secondary mr-2">{{ 'QUOTE.DETAIL.OVERVIEW_NEW.GO_TO' | translate }}</span>
            <i class="pi pi-arrow-right text-sm text-secondary"></i>
        </div>
    </div>
    }

    <!-- Dialog Footer -->
    <div class="flex justify-content-end pt-3">
        <p-button [label]="'CLOSE' | translate" [text]="true" (onClick)="close()" />
    </div>
</div>